import React, { Component } from 'react';
import ItemsList from '../containers/itemsList';
import ItemDetails, { Field } from '../containers/itemDetails';
import ErrorMessage from '../components/errorMessage';
import RowBlock from '../hoc/rowBlock';
import { HOUSES } from '../utils/constants';
import Layout from '../hoc/layout';
import withGoTService from '../hoc/withGoTService';
import { object } from 'prop-types';

class HousePage extends Component {
  static propTypes = {
    gotService: object,
  }

  state = {
    selectedHouse: null,
    error: false,
  }

  onItemSelected = id => {
    this.setState({
      selectedHouse: id
    })
  }

  componentDidCatch() {
    this.setState({ error: true })
  }

  render() {
    const { selectedHouse, error } = this.state
    const { gotService } = this.props

    if (error) {
      return <ErrorMessage />
    }

    const itemList = (
      <ItemsList
        onItemSelected={this.onItemSelected}
        getData={gotService.getAllItems.bind(null, HOUSES)}
        renderItem={({ name }) => name}
      />
    )

    const houseDetails = (
      <ItemDetails
        itemId={selectedHouse}
        itemType={HOUSES}
      >
        <Field field='region' label='Region' />
        <Field field='words' label='Words' />
        <Field field='titles' label='Titles' />
        <Field field='overlord' label='Overlord' />
        <Field field='ancestralWeapons' label='Ancestral Weapons' />
      </ItemDetails>
    )

    return (
      <Layout>
        <RowBlock left={itemList} right={houseDetails} />
      </Layout>
    )
  }
}

export default withGoTService()(HousePage)
